// Abbott | FreeStyle Libre Experience
export const FSLE_QID = '649261b0c2dbf22e284a0347';
export const PROGRAM_FREESTYLELIBRE_DETAILS= 1;
export const PROGRAM_FREESTYLELIBRE_SIGNUP = 2;
export const PROGRAM_FREESTYLELIBRE_CONFIRMATION = 3;
